<script setup lang="ts">
import LegendsList from "@/components/legends/LegendsList.vue";
</script>

<template>
  <div><LegendsList /></div>
</template>

<style lang="scss" scoped></style>
